<template>
  <div>
    <DataTable
        :filters="filters"
        :loading="loading"
        :paginator="true"
        :resizableColumns="true"
        :rows="rows"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :scrollable="true"
        :selection.sync="selection"
        :value="dataRows"
        columnResizeMode="expand"
        selection-mode="multiple"
        style="max-width: 100% !important;"
    >
      <Column :header="translate('header.option.type')" :sortable="true" field="optionType">
      </Column>
      <Column :header="translate('header.option.activated')" :sortable="true" field="activated"></Column>
      <Column :header="translate('header.option.contractNumber')" :sortable="true" field="contractNumber"></Column>
      <Column :header="translate('header.start')" field="from">
        <template #body="slotProps">
          {{ renderDateIntl(slotProps.data.from) }}
        </template>
      </Column>
      <Column :header="translate('header.end')" field="until">
        <template #body="slotProps">
          {{ renderDateIntl(slotProps.data.until) }}
        </template>
      </Column>
      <Column :header="translate('header.option.remark')" :sortable="true" field="remark"></Column>
      <Column :header="translate('header.option.warningTime')" :sortable="true" field="warningTime"></Column>
      <Column :header="translate('header.option.deadline')" :sortable="true" field="deadline"></Column>

      <template #paginatorLeft>
        <div>
          Count: {{ recordCount }}
        </div>
      </template>
      <template #empty>
        {{ translate('no.records') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {renderContactType, renderDate} from './renderer';
import TranslateService from "../services/translate.service";

export default {
  name: "OptionsGrid",
  props: ['dataRows', 'loading'],
  data() {
    return {
      filters: {},
      selection: [],
      rows: 10
    }
  },
  methods: {
    renderType(type) {
      return renderContactType(type);
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    renderDateIntl: renderDate
  },
  computed: {
    ...mapGetters('nav', ['getContentWidth']),
    recordCount() {
      return this.dataRows.length;
    },

  }
}
</script>

<style scoped>

</style>